import * as actionTypes from '../actions/actionTypes';

const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

const initialState = {
    payment: null,
    paymentMethod: null,
    customer: null,
    invoices: null,
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.UPDATE_PAYMENT:
            return updateObject(state, {})
        case actionTypes.UPDATE_PAYMENT_METHOD:
            return updateObject(state, { paymentMethod: action.paymentMethod })
        case actionTypes.UPDATE_CUSTOMER:
            return updateObject(state, { customer: action.customer })
        case actionTypes.UPDATE_INVOICES:
            return updateObject(state, { invoices: action.invoices })
        default:
            return updateObject(state)
    }
};

export default reducer;
